import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { MOBILE_SLIDER_PAGES_IDS } from "../../MobileSliderPages/mobileSliderPagesConstants";
import { MOBILE_HISTORY_INFO_TYPES } from "../mobileHistoryConstants";
import { IconAsset } from "../../../../components/icon/Icon";
import classNames from "classnames";
import amountFormat from "../../../../utils/amountFormat";
import { useCallback } from "react";
import { openMobileSliderPageAction } from "../../../mobileAppActions";
import { setAccountSelectedHistoryInfoAction } from "../../../../modules/Account/accountActions";
import { connect } from "react-redux";
import { LITE_TRADE_POSITION_SIDE } from "../../../../modules/LiteTrade/liteTradeConstants";
import { createStructuredSelector } from "reselect";
import { getLiteTradeAssetsBySymbol } from "../../../../modules/LiteTrade/liteTradeSelectors";
import {
    MobileHistoryRowAmountStyled,
    MobileHistoryRowIconContainerStyled,
    MobileHistoryRowStyled
} from "../styled/MobileHistoryRowStyled";

function MobileHistoryPositionRow(props) {
    const {assetsBySymbol, item, openMobileSliderPage, setAccountSelectedHistoryInfo} = props;
    const {getLangPath} = useLangContext();
    const asset = assetsBySymbol[item.symbol];
    const isBuy = item.side === LITE_TRADE_POSITION_SIDE.BUY;

    const handleRowClick = useCallback(() => {
        setAccountSelectedHistoryInfo({info: item, type: MOBILE_HISTORY_INFO_TYPES.POSITION});
        openMobileSliderPage({
            name: MOBILE_SLIDER_PAGES_IDS.HISTORY_INFO,
            type: MOBILE_HISTORY_INFO_TYPES.POSITION,
            id: item.position_code,
        });
    }, [item, openMobileSliderPage, setAccountSelectedHistoryInfo]);

    return <MobileHistoryRowStyled onClick={handleRowClick}>
        <MobileHistoryRowIconContainerStyled>
            <IconAsset symbol={item.symbol}/>
        </MobileHistoryRowIconContainerStyled>
        <div className="flex-1 overflow-hidden">
            <div className="f16 text-truncate">
                {getLangPath(`lite_version.history.${isBuy ? 'bought_asset' : 'sold_asset'}`, {asset: asset?.info?.description})}
            </div>
            <div className="color-white-60">{item.symbol}</div>
        </div>
        <div className="ms-2">
            {
                !!item.pl ? (
                    <MobileHistoryRowAmountStyled className={classNames('f16 text-end', {
                        'negative': item.pl < 0,
                        'positive': item.pl > 0,
                    })}>
                        {amountFormat(item.pl, 2, '$')}
                    </MobileHistoryRowAmountStyled>
                ) : <div/>
            }
            <div className="color-white-60 text-end">{item.formattedDate}</div>
        </div>
    </MobileHistoryRowStyled>
}

const mapStateToProps = createStructuredSelector({
    assetsBySymbol: getLiteTradeAssetsBySymbol,
})

const mapDispatchToProps = (dispatch) => ({
    openMobileSliderPage: payload => dispatch(openMobileSliderPageAction(payload)),
    setAccountSelectedHistoryInfo: payload => dispatch(setAccountSelectedHistoryInfoAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileHistoryPositionRow);
